import { LoadingButton } from "@mui/lab";
import { Alert, Box, Stack, TextField, Typography } from "@mui/material";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocationsThunk,
  locationSelector,
} from "store/reducers/inventory/locationSlice";
import { distributorStockTransactionThunk } from "store/reducers/inventory/stock/distributorStockSlice";
import * as yup from "yup";

const TransferDistributorStock = ({ open, handleClose, stock }) => {
  const dispatch = useDispatch();
  const validation = yup.object({
    qty: yup.number().required().positive().min(1).max(stock.qty),
  });
  const formik = useFormik({
    initialValues: {
      location: null,
      qty: stock.qty,
      product_variant: stock.product_variant,
      in_or_out: "out",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      //   console.log(data);
      dispatch(
        distributorStockTransactionThunk({
          stock,
          data: { ...data, location: data.location.id },
        })
      );
    },
    enableReinitialize: true,
  });
  const state = useSelector(
    (state) => state.distributorStock.distributorStockTransactionStatus
  );
  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);
  const locations = useSelector(locationSelector.selectAll);
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Transfer stock"
    >
      <Box padding={2}>
        <Typography variant="h6" color="text.secondary">
          You are about to return the following product
        </Typography>
        <Typography variant="h5" color="text.secondary">
          {stock.name}
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ marginTop: 2 }}>
          <Stack direction="column" spacing={2}>
            <TextField
              fullWidth
              name="qty"
              value={formik.values.qty}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.qty)}
              helperText={formik.errors.qty}
              type="number"
            />
            <AutoCompleteListFormik
              items={locations}
              name="name"
              label="Choose location"
              formik={formik}
              formikName="location"
              required={true}
            />
          </Stack>
          {state?.error === "get" && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred , {state?.errorMessage}
            </Alert>
          )}

          {state?.success === "get" && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            sx={{ mt: 2 }}
            variant="outlined"
            type="submit"
            loading={state?.loading === "get"}
          >
            Submit
          </LoadingButton>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default TransferDistributorStock;
